export function getAll() {
  let items = [
    // {
    //   value: 0,
    //   name: "All",
    //   text: "全部",
    // },
    {
      value: true,
      name: "Completed",
      text: "已上傳",
    },
    {
      value: false,
      name: "NotCompleted",
      text: "未上傳",
    },
  ];
  return items;
}
